import { useState } from "react";

import FormComp from "../FormComp";
import Overlay from "../Overlay";
import Formulario from "../Utils/Formulario";
import Modal from "../Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import useApi from "../../hooks/useApi";

const ModalNovoEmailTransferencia = ({ obras = [], onCreated }) => {

    const { closeModal } = useModal();
    const api = useApi();

    const [cc, setCc] = useState("");
    const [email, setEmail] = useState("");
    const [salvando, setSalvando] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!cc) {
            alert("Selecione o centro de custo.");
            return;
        }

        if (!email) {
            alert("Informe o e-mail.");
            return;
        }

        try {

            setSalvando(true);

            await api.post("/Painel/API/Transferencia/AddEmail/", { cc, email });

            if (onCreated) await onCreated();
            closeModal();

        } catch (err) {

            console.error(err);
            const msg = err?.response?.data?.message || "Erro ao salvar e-mail.";
            alert(msg);

        } finally {

            setSalvando(false);

        }

    };

    return (
        <Overlay state={ true } >
            <Modal header close={ closeModal } size="sm" >
                <Formulario onSubmit={ handleSubmit } >
                    <FormComp
                        title="CENTRO DE CUSTO"
                        type="select"
                        options={ obras }
                        valor={ cc }
                        name="cc"
                        changeFunc={ (e) => setCc(e.target.value) }
                        required
                    />
                    <FormComp
                        title="E-MAIL"
                        type="email"
                        valor={ email }
                        name="email"
                        placeholder="exemplo@palmont.com.br"
                        changeFunc={ (e) => setEmail(e.target.value.toLowerCase()) }
                        required
                    />
                    <FormComp
                        type="submit"
                        valor={ salvando ? "SALVANDO..." : "SALVAR" }
                        disabled={ salvando }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    );

};

export default ModalNovoEmailTransferencia;
